var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2495_4141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4683 0.53198C11.1271 0.191331 10.6647 0 10.1826 0C9.70049 0 9.23808 0.191331 8.89692 0.53198L0.735186 8.69388C0.50146 8.9263 0.31614 9.20275 0.189948 9.50725C0.0637568 9.81176 -0.000801909 10.1383 7.518e-06 10.4679V11.4982C7.518e-06 11.6312 0.0528785 11.7589 0.14699 11.853C0.241101 11.9471 0.368742 12 0.501835 12H1.53209C1.86167 12.0009 2.18816 11.9365 2.49267 11.8104C2.79717 11.6842 3.07363 11.499 3.30605 11.2653L11.4683 3.1029C11.8088 2.76175 12 2.29944 12 1.81744C12 1.33544 11.8088 0.873133 11.4683 0.53198ZM2.59647 10.5557C2.31344 10.8369 1.93102 10.9952 1.53209 10.9963H1.00366V10.4679C1.00316 10.2701 1.04188 10.0742 1.1176 9.89149C1.19331 9.70879 1.30452 9.54291 1.44477 9.40348L7.63883 3.20929L8.79304 4.36352L2.59647 10.5557ZM10.7582 2.3933L9.50061 3.65141L8.34641 2.49718L9.60449 1.23907C9.75755 1.08601 9.96514 1.00002 10.1816 1.00002C10.2888 1.00002 10.3949 1.02113 10.4939 1.06215C10.5929 1.10316 10.6829 1.16328 10.7587 1.23907C10.8345 1.31486 10.8946 1.40483 10.9356 1.50385C10.9766 1.60287 10.9977 1.709 10.9977 1.81618C10.9977 1.92336 10.9766 2.0295 10.9356 2.12852C10.8946 2.22754 10.8345 2.31751 10.7587 2.3933H10.7582Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2495_4141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.47c630c66b01bf22b98eea62eb037ad1.svg";
export { ForwardRef as ReactComponent };